

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DeployDialog from './DeployDialog.vue';
import { Deployment, Response } from '@/types';
import Constants from '@/constants';
import { DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT } from '@/store/mutypes';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEllipsisV } from '@fortawesome/pro-light-svg-icons';
import { ElNotificationOptions } from 'element-ui/types/notification';
library.add(faEllipsisV);

@Component({
  name: 'more-actions-button',
  components: {
    DeployDialog
  }
})
export default class MoreActionsButton extends Vue {
  @Prop({ required: true })
  deployment!: Deployment;

  get isNew() {
    return this.deployment.status === Constants.DEPLOYMENT_STATUS_NEW;
  }

  get isSuspended() {
    return this.deployment.status === Constants.DEPLOYMENT_STATUS_SUSPENDED;
  }

  get isActive() {
    return this.deployment.status === Constants.DEPLOYMENT_STATUS_ACTIVE;
  }

  async handleCommand(command: string) {
    interface CommandsType {
      [command: string]: { action: string; message: string };
    }

    const commands: CommandsType = {
      suspend: {
        action: 'suspendDeployment',
        message: 'Are you sure to suspend this deployment?'
      },
      resume: {
        action: 'resumeDeployment',
        message: 'Are you sure to unsuspend this deployment?'
      },
      delete: {
        action: 'purgeDeployment',
        message:
          'Are you sure to delete this deployment? This action will remove all data!!!'
      }
    };
    try {
      await this.$confirm(commands[command]['message'], 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      const resp: Response = await this.$store.dispatch(
        commands[command]['action'],
        this.deployment.id
      );
      this.$notify({
        title: resp.status,
        type: resp.status as ElNotificationOptions['type'],
        message: resp.message
      });
      this.$emit('done');
    } catch (e) {
      // blank
    }
  }
}
